"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateRfpDetailsEntryDto = exports.CreateRfpDetailsEntryDocumentMapDto = exports.CreateOpportunityRfpDetailsEntryDto = exports.CreateRfpCreditSharingDto = exports.CreateRfpClientContactDetailsDto = exports.CreateRfpInsurerDetailsDto = exports.CreateRfpTpaDetailsDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const mapped_types_1 = require("@nestjs/mapped-types");
// Nested DTO for descriptionRequirements
class DescriptionRequirementsDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], DescriptionRequirementsDto.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], DescriptionRequirementsDto.prototype, "requirements", void 0);
// Nested DTO for dynamicQuote
class DynamicQuoteDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], DynamicQuoteDto.prototype, "multipleBrokerInvolved", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], DynamicQuoteDto.prototype, "isMarketAllocationDone", void 0);
// Nested DTO for targetQcrDate
class TargetQcrDateDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)({ message: "Receipt date must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Receipt date must be in the format YYYY-MM-DD.",
    }),
    tslib_1.__metadata("design:type", String)
], TargetQcrDateDto.prototype, "targetQcrDate", void 0);
// Nested DTO for clientConsiderations
class ClientConsiderationsDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ClientConsiderationsDto.prototype, "clientConsiderations", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ClientConsiderationsDto.prototype, "threatsFromExistingInsurer", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ClientConsiderationsDto.prototype, "threatsFromExistingBroker", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ClientConsiderationsDto.prototype, "extraneousFactors", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ClientConsiderationsDto.prototype, "planForClosingDetail", void 0);
// Nested DTO for remarks
class RemarksDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], RemarksDto.prototype, "remarks", void 0);
class CreateRfpTpaDetailsDto {
}
exports.CreateRfpTpaDetailsDto = CreateRfpTpaDetailsDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpTpaDetailsDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpTpaDetailsDto.prototype, "tpaId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpTpaDetailsDto.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpTpaDetailsDto.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpTpaDetailsDto.prototype, "contactId", void 0);
class CreateRfpInsurerDetailsDto {
}
exports.CreateRfpInsurerDetailsDto = CreateRfpInsurerDetailsDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpInsurerDetailsDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpInsurerDetailsDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpInsurerDetailsDto.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpInsurerDetailsDto.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpInsurerDetailsDto.prototype, "contactId", void 0);
class CreateRfpClientContactDetailsDto {
}
exports.CreateRfpClientContactDetailsDto = CreateRfpClientContactDetailsDto;
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpClientContactDetailsDto.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsNumber)({}, { each: true }),
    tslib_1.__metadata("design:type", Array)
], CreateRfpClientContactDetailsDto.prototype, "decisionInfluencers", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpClientContactDetailsDto.prototype, "expectedPremium", void 0);
class CreateRfpCreditSharingDto {
}
exports.CreateRfpCreditSharingDto = CreateRfpCreditSharingDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpCreditSharingDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpCreditSharingDto.prototype, "executiveId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpCreditSharingDto.prototype, "percentage", void 0);
class CreateOpportunityRfpDetailsEntryDto {
}
exports.CreateOpportunityRfpDetailsEntryDto = CreateOpportunityRfpDetailsEntryDto;
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityRfpDetailsEntryDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DescriptionRequirementsDto),
    tslib_1.__metadata("design:type", DescriptionRequirementsDto)
], CreateOpportunityRfpDetailsEntryDto.prototype, "descriptionRequirements", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CreateRfpInsurerDetailsDto),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityRfpDetailsEntryDto.prototype, "preferredInsurers", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CreateRfpInsurerDetailsDto),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityRfpDetailsEntryDto.prototype, "excludedInsurers", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CreateRfpTpaDetailsDto),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityRfpDetailsEntryDto.prototype, "preferredTPA", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CreateRfpTpaDetailsDto),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityRfpDetailsEntryDto.prototype, "excludedTPA", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DynamicQuoteDto),
    tslib_1.__metadata("design:type", DynamicQuoteDto)
], CreateOpportunityRfpDetailsEntryDto.prototype, "dynamicQuote", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => TargetQcrDateDto),
    tslib_1.__metadata("design:type", TargetQcrDateDto)
], CreateOpportunityRfpDetailsEntryDto.prototype, "targetQcrDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => ClientConsiderationsDto),
    tslib_1.__metadata("design:type", ClientConsiderationsDto)
], CreateOpportunityRfpDetailsEntryDto.prototype, "clientConsiderations", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => RemarksDto),
    tslib_1.__metadata("design:type", RemarksDto)
], CreateOpportunityRfpDetailsEntryDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CreateRfpClientContactDetailsDto),
    tslib_1.__metadata("design:type", CreateRfpClientContactDetailsDto)
], CreateOpportunityRfpDetailsEntryDto.prototype, "clientContactDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CreateRfpCreditSharingDto),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityRfpDetailsEntryDto.prototype, "creditSharing", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CreateRfpDetailsEntryDocumentMapDto),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityRfpDetailsEntryDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityRfpDetailsEntryDto.prototype, "statusLid", void 0);
class CreateRfpDetailsEntryDocumentMapDto {
}
exports.CreateRfpDetailsEntryDocumentMapDto = CreateRfpDetailsEntryDocumentMapDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpDetailsEntryDocumentMapDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpDetailsEntryDocumentMapDto.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreateRfpDetailsEntryDocumentMapDto.prototype, "documentTypeLid", void 0);
class UpdateRfpDetailsEntryDto extends (0, mapped_types_1.PartialType)(CreateOpportunityRfpDetailsEntryDto) {
}
exports.UpdateRfpDetailsEntryDto = UpdateRfpDetailsEntryDto;
